/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highvalue_Transaction_InsuranInputs */

const en_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-value transaction insurance`)
};

const es_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro de transacciones de alto valor`)
};

const fr_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assurance pour transactions de grande valeur`)
};

const de_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versicherung für hochwertige Transaktionen`)
};

const ja_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高額取引の保険`)
};

const zh_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高价值交易担保`)
};

const ar_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأمين المعاملات عالية القيمة`)
};

const id_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asuransi transaksi bernilai tinggi`)
};

const it_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assicurazione per transazioni di alto valore`)
};

const ru_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страхование крупных сделок`)
};

const pt_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro para transações de alto valor`)
};

const ko_highvalue_transaction_insuran = /** @type {(inputs: Highvalue_Transaction_InsuranInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고가 거래 보험`)
};

/**
* | output |
* | --- |
* | "High-value transaction insurance" |
*
* @param {Highvalue_Transaction_InsuranInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const highvalue_transaction_insuran = /** @type {((inputs?: Highvalue_Transaction_InsuranInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highvalue_Transaction_InsuranInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_highvalue_transaction_insuran(inputs)
	if (locale === "es") return es_highvalue_transaction_insuran(inputs)
	if (locale === "fr") return fr_highvalue_transaction_insuran(inputs)
	if (locale === "de") return de_highvalue_transaction_insuran(inputs)
	if (locale === "ja") return ja_highvalue_transaction_insuran(inputs)
	if (locale === "zh") return zh_highvalue_transaction_insuran(inputs)
	if (locale === "ar") return ar_highvalue_transaction_insuran(inputs)
	if (locale === "id") return id_highvalue_transaction_insuran(inputs)
	if (locale === "it") return it_highvalue_transaction_insuran(inputs)
	if (locale === "ru") return ru_highvalue_transaction_insuran(inputs)
	if (locale === "pt") return pt_highvalue_transaction_insuran(inputs)
	return ko_highvalue_transaction_insuran(inputs)
});